import { createSelector } from 'reselect'

import _ from 'lodash'

import { RootState } from '../types'
import { paramSelector } from '../../utils/selectors'

type WithCompanyId = {
  companyId: string
}

type WithCompanyIdentifier = {
  companyIdentifier: string
}

export const selectState = (state: RootState) => state.companyDetail

export const getCompanyByIdentifier = createSelector(
  selectState,
  paramSelector<WithCompanyIdentifier>(),
  // eslint-disable-next-line lodash/matches-shorthand
  ({ companies }, { companyIdentifier }) => _.find(companies, x => x.company.companyIdentifier === companyIdentifier)
)

export const getCompany = createSelector(
  selectState,
  paramSelector<WithCompanyId>(),
  ({ companies }, { companyId }) => companies[companyId]
)

export const isCompanyLoading = createSelector(
  selectState,
  paramSelector<WithCompanyIdentifier>(),
  ({ loadingEntities }, { companyIdentifier }) => loadingEntities[companyIdentifier] || false
)
